import PageHeader from '../components/common/PageHeader';

/**
 * A placeholder for the full activity log. The dashboard's Recent Activity already links here
 * through its "View all", so the route has to exist; the page itself, with its filters and search,
 * belongs to its own story.
 */
export default function ActivityLogPage() {
  return (
    <div>
      <PageHeader title="Activity Log" />
      <div className="overflow-hidden rounded-lg border border-border bg-surface">
        <p className="p-8 text-center text-sm text-content-secondary">
          The full activity log is not available yet. The dashboard shows the most recent entries.
        </p>
      </div>
    </div>
  );
}
